import { DispatchLeg } from '@api/Trinium/Endpoints/Dispatch/types';
import DateSlot from '@components/DataGrid/DateSlot';
import RenderCell from '@components/DataGrid/RenderCell';
import { dateSortComparator } from '@components/DataGrid/types';
import { applyColumnQuickFilter, caseInsensitiveIncludes } from '../columns';
import RenderHeader from '@components/DataGrid/RenderHeader';
import { GridColDefExtended } from '@mui/x-data-grid-pro';

const deliverDateDefinition: GridColDefExtended<DispatchLeg> = {
	field: 'Delivery Date',
	minWidth: 130,
	width: 150,
	headerName: 'Delivery Date',
	renderHeader: () => <RenderHeader primaryText='Delivery Date' />,
	renderCell: ({ row }) => (
		<RenderCell
			primarySlot={
				<DateSlot
					toDate={row.deliverDate}
					fullDate
					dateOnly
				/>
			}
		/>
	),
	disableReorder: true,
	getApplyQuickFilterFn: (value: string) => {
		return (_, row): boolean =>
			applyColumnQuickFilter(value, row, (value: string, row: DispatchLeg) => {
				const { deliverDate } = row;
				return caseInsensitiveIncludes(value, deliverDate);
			});
	},
	valueGetter: (_, row: DispatchLeg) => row.deliverDate?.date ?? '',
	sortable: true,
	sortComparator: dateSortComparator
};

export default deliverDateDefinition;
